import React from 'react'
import EmbedNode from '../EmbedNode'

export default function GoogleSheetsNode({id,data,selected,...props}) {
    return (
        <EmbedNode domain='sheets.google.com' className='' text='Google Sheets Link' transformUrl={(url) => (url.includes('?')&&!url.includes('embedded=true'))? url+'&embedded=true':url+'?embedded=true'} id={id} data={data} selected={selected} {...props} />
    )
}
